/* eslint-disable */
import Vue from 'vue';

import {
  BVConfigPlugin,
  ButtonPlugin,
  ImagePlugin,
  FormPlugin,
  FormInputPlugin,
  FormCheckboxPlugin,
  FormRadioPlugin,
  FormSelectPlugin,
  LayoutPlugin,
  LinkPlugin,
  IconsPlugin,
  BFormGroup,
  FormTextareaPlugin,
} from 'bootstrap-vue';

Vue.use(BVConfigPlugin, {
  BButton: { variant: 'primary' }
})

Vue.use(ButtonPlugin);
Vue.use(ImagePlugin);
Vue.use(FormPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(FormRadioPlugin);
Vue.use(FormSelectPlugin);
Vue.use(LayoutPlugin);
Vue.use(LinkPlugin);
Vue.use(IconsPlugin);
Vue.component('b-form-group', BFormGroup);
Vue.use(FormTextareaPlugin);
